module.exports = __webpack_public_path__ + "static/media/liebherr40.bebb4a85.pdf";